module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAYAAABXNvynAAAABGdBTUEAALGPC/xhBQAAAStJREFUWAntlTFqAkEUhv8ZXNK5XkAstrJLEYiQnMRD2MlWVluJkMIqJ/AmFoEU6SzEwhu4whYizPjeBIJs/btkYB4M7OzAzsc3/5s1/hMeEZWNiDWgJuBHn1gynAy3DKRItITQp9EZNk3TRPWn6zHPrK4vWK9/cL268Nkss5jNnpHnT7RtaMAKW5ZbzOcvcM7BGMiw4d1y+UaDpkWiqr4wnY5xPJ5wOJzFqEdR5BiNBthsdlgsXimWaYY1Bt47ga2x3yuwKJYxHPb/IsIgpgErjA/tq6BennXiQzR0jVU0YG0wa63EoC9svxePRkJzrGusomX4vuk0GloKu1p94182nQJ2ca3RDCtwF2UmH+9R/el43dCFXtkjAT9adDKcDLcMpEi0hNCn0Rm+AR22ZkXgpR5GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag-icons/icons8-india.png
// module id = 1407
// module chunks = 33